export default "__VITE_ASSET__DoE4iMcv__"